<template>
  <vxe-grid
    border
    show-overflow
    resizable
    ref="followingRecordsTableRef"
    class="vxe-table-element"
    size="mini"
    align="center"
    :auto-resize="true"
    :data="data"
    :toolbar="{}"
    :valid-config="{ autoPos: true, message: 'inline' }"
    @select-change="handleSelectionChange"
    @select-all="handleSelectionChange"
    @edit-closed="closeEditTableHandler"
    :edit-config="disabled ? {} : { trigger: 'click', mode: 'row' }"
    height="300"
  >
    <template v-slot:buttons v-if="!disabled">
      <el-button @click="newRowHandler" size="small" type="primary" class="vxe-btn-primary"
        >新增</el-button
      >
      <el-button @click="deleteRowHandler" size="small" type="danger" class="vxe-btn-delete"
        >删除</el-button
      >
    </template>
    <vxe-table-column type="checkbox" width="50" fixed="left" v-if="!disabled"> </vxe-table-column>
    <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
    <vxe-table-column
      v-for="(item, index) in columns"
      :key="index"
      :type="item.type"
      :fixed="item.fixed"
      :field="item.field"
      :title="item.title"
      :width="item.width"
      :edit-render="item.editRender"
    >
      <template v-slot:edit="{ row }">
        <el-date-picker
          v-if="item.editRender.name == 'followDate'"
          clearable
          style="width: 100%"
          v-model="row[item.editRender.name]"
          type="date"
          placeholder="跟进时间"
          value-format="yyyy-MM-dd"
        />
        <search-table
          v-else-if="item.editRender.name == 'followPersonNo'"
          v-model="row[item.editRender.name]"
          searchType="personnel"
          :currentValue="row['followPersonName']"
          :checkRowKeys="[row['followPersonNo']]"
          :isMultiple="true"
          @input="(val) => handleChange(val, row, 'followPersonNo')"
        />
        <el-input
          v-else
          v-model="row[item.editRender.name]"
          placeholder="请输入"
          maxlength="200"
          clearable
        />
      </template>
    </vxe-table-column>
  </vxe-grid>
</template>

<script>
  export default {
    name: 'FollowingRecordsTable',
    props: {
      tableData: {
        type: Array,
        default: () => [],
      },
      disabled: {
        type: Boolean,
        default: () => false,
      },
    },
    watch: {
      tableData: {
        handler(val) {
          if (val && val.length) {
            this.fullTableData(val);
          }
        },
        immediate: true,
        deep: true,
      },
    },
    data() {
      return {
        tableTotal: 0,
        selectedList: [],
        data: [],
        columns: [
          {
            field: 'followDate',
            title: '跟进时间',
            width: '150',
            editRender: { name: 'followDate' },
          },
          {
            field: 'followPersonName',
            title: '跟进人',
            width: '150',
            editRender: { name: 'followPersonNo' },
          },
          {
            field: 'followInfo',
            title: '跟进情况',
            width: '300',
            editRender: { name: 'followInfo' },
          },
          {
            field: 'remark',
            title: '备注',
            width: '400',
            editRender: { name: 'remark' },
          },
        ],
      };
    },
    methods: {
      handleChange(val, row, field) {
        console.log('change', val, row, field);
        if (field == 'followPersonNo') {
          if (val && val[0]) {
            row['followPersonName'] = val[0].personName;
            row['followPersonNo'] = val[0].id;
          }
        }
      },
      // 获取表格数据
      getTableData() {
        const $table = this.$refs.followingRecordsTableRef;
        return $table.getTableData().fullData;
      },
      // 反填数据
      fullTableData(val) {
        if (val && val.length) {
          this.data = val;
        } else {
          this.data = [];
        }
      },
      // 新增行
      async newRowHandler() {
        this.clearSelection();
        const $table = this.$refs.followingRecordsTableRef;
        const rowData = {};
        $table.setRadioRow(rowData);
        this.insertEvent(rowData, 0);
      },
      async insertEvent(rowData = {}, index = 0) {
        const $table = this.$refs.followingRecordsTableRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (!errMap) {
          const { row: newRow } = await $table.insertAt(rowData, index);
          await $table.setActiveRow(newRow); // 设置当前行为活跃
          await $table.validate(newRow).catch((errMap) => errMap);
        }
      },
      deleteRowHandler() {
        if (this.selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('billDetail.message.noData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$refs.followingRecordsTableRef.removeSelecteds();
            this.$emit('handleTableChange', 'followingRecords', this.getTableData());
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('billDetail.message.deleteSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('billDetail.message.cancelled'),
            });
          });
      },
      clearSelection() {
        this.$refs.followingRecordsTableRef.clearCheckboxRow();
        this.selectedList = [];
      },
      handleSelectionChange({ selection }) {
        console.log(selection, '选择行');
        this.selectedList = selection;
      },
      async closeEditTableHandler() {
        console.log('关闭');
        const $table = this.$refs.followingRecordsTableRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (errMap) {
          this.$message.error('请检查数据再提交');
        } else {
          // 派发事件
          this.$emit('handleTableChange', 'followingRecords', this.getTableData());
          await $table.clearActived();
        }
      },
    },
  };
</script>
